import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getReportList({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query {
        reports {
         created
         filename
         status
         display_name
        }
      }`)
      .then(({ data }) => {
        const { reports } = data || {};
        commit('setReports', reports);
        commit('toggleLoading', false);
      })
      .catch(() => commit('toggleLoading', false));
  },
  download({ commit }, param) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query ($filename: String!) {
        downloadPreInvoice(filename: $filename) {
          download_url
        }
      }`, param)
        .then(({ data }) => {
          const { downloadPreInvoice } = data || {};
          commit('toggleLoading', false);
          window.open(downloadPreInvoice.download_url, '_black');
        })
        .catch(() => commit('toggleLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/files/pre-invoice-generation/store/actions.js